import axios from 'axios'
const API = axios.create({
    baseURL: 'http://81.68.174.34:9002'
})
export default API